<!-- 答题卡 -->
<template>
  <div
    class="answer-sheet-wrap"
    :class="{
      'answer-sheet-wrap-electron': isElectron,
    }"
  >
    <!-- 抽屉容器 -->
    <div
      class="drawer"
      :class="{ 'drawer-open': isDrawerOpen }"
      :style="handleDrawerStyle"
    >
      <!-- 开关按钮 -->
      <button class="drawer-toggle" @click="toggleDrawer">
        <p class="num-wrap">
          <span class="name">答题卡</span>
          <!-- 已批改 -->
          <span v-if="isCorrected" class="left-num right-num">{{
            rightNum
          }}</span>
          <span v-else class="left-num">{{ answeredNum }}</span>
          <span class="total-num">/{{ questionList.length }}</span>
        </p>
      </button>
      <!-- 抽屉内容 -->
      <div class="drawer-content">
        <ul class="number-wrap">
          <li
            @click="handleNumberClick(item)"
            class="number-item"
            v-for="(item, index) in questionList"
            :key="item.question_id"
            :class="{
              'is-answer': item.is_answer,
              'is-right': isCorrected && item.is_answer && item.is_right,
              'is-wrong': isCorrected && item.is_answer && !item.is_right,
            }"
          >
            {{ index + 1 }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { WORK_STATUS } from "@saas/components/src/constants/question";
import { EventBus } from "@saas/components/src/utils/event-bus";
import { mapState, mapGetters } from "vuex";
export default {
  data() {
    return {
      isDrawerOpen: false,
      minHeight: 87,
      hetght: 87,
      WORK_STATUS,
      isElectron: window.isElectron,
    };
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        // 初始化-答题卡高度及位置
        this.height =
          document.querySelector(".answer-sheet-wrap .drawer")?.clientHeight ||
          this.minHeight;
        document.querySelector(
          ".answer-sheet-wrap .drawer"
        ).style.bottom = `-${this.height}px`;
      }, 200);
    });
    // 处理自动跳转下一题
    EventBus.$off(`answer-sheet-auto-next-question`);
    EventBus.$on(`answer-sheet-auto-next-question`, this.handleNumberClick);
  },
  computed: {
    ...mapGetters("defaultHomework", ["canSubmit", "answeredNum", "rightNum"]),
    ...mapState("defaultHomework", [
      "workInfo",
      "questionList",
      "isCorrected",
      "showErrorAnalysis",
    ]),
    handleDrawerStyle() {
      return {
        bottom: this.isDrawerOpen ? 0 : `-${this.height}px`,
      };
    },
  },
  methods: {
    toggleDrawer() {
      this.isDrawerOpen = !this.isDrawerOpen;
      // 调整页面底部padding高度
      if (this.height > this.minHeight) {
        this.$emit("toggleAnswerSheet", {
          drawerHeight: this.height,
          isDrawerOpen: this.isDrawerOpen,
        });
      }
    },
    // 跳转到指定题目
    handleNumberClick(item) {
      let { question_id, question_pid, sub_index, is_answer, is_right } = item;
      if (this.showErrorAnalysis && this.isCorrected && is_answer && is_right) {
        return false;
      }
      let el = document.querySelector(
        `.question_${question_pid || question_id}`
      );
      if (el) {
        if (window.isElectron) {
          document.querySelector("#electron-main").scrollTo({
            top: el?.offsetTop || 0,
            behavior: "smooth",
          });
        } else {
          el.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }
      if (question_pid) {
        EventBus.$emit(`answer-sheet-click-${question_pid}`, {
          question_id,
          sub_index,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$drawer-min-height: 87px;
.answer-sheet-wrap {
  position: relative;
}
.drawer {
  position: fixed;
  bottom: -500px; /* 初始位置在屏幕下方 */
  left: 50%;
  transform: translate(-50%, 0);
  width: 1200px;
  min-height: $drawer-min-height;
  background-color: #fff;
  border-radius: 0px 12px 0px 0px;
  transition: bottom 0.3s ease-in-out;
}

.drawer-open {
  bottom: 0; /* 打开时显示在屏幕底部 */
  .drawer-toggle {
    background: url("../../../assets/images/homework/sheet-bg-down.png")
      no-repeat;
    background-size: 100% 100%;
  }
}

.drawer-toggle {
  position: absolute;
  top: -44px;
  left: -8px;
  z-index: 9;
  width: 165px;
  height: 50px;
  background: #ffffff;
  // padding: 0 0 0 12px;
  cursor: pointer;
  // border: 1px solid red;
  background: url("../../../assets/images/homework/sheet-bg-up.png") no-repeat;
  background-size: 100% 100%;
  line-height: 1;
  .num-wrap {
    margin-right: 30px;
  }
  .name-wrap {
    display: flex;
    align-items: center;
  }
  .name {
    font-weight: 500;
    font-size: 16px;
    color: #1d2129;
    margin-right: 12px;
    // line-height: 22px;
  }
  .left-num {
    font-weight: 500;
    font-size: 16px;
    color: #1d2129;
    // line-height: 1;
    &.right-num {
      color: $homework-right-color;
    }
  }
  .total-num {
    position: relative;
    bottom: 1px;
    font-size: 11px;
    color: #86909c;
  }
}

.drawer-content {
  padding: 20px 5px 17px;
  .number-wrap {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .number-item {
    width: 30px;
    height: 30px;
    background: #f2f3f5;
    font-weight: 500;
    font-size: 16px;
    color: #4e5969;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin: 0 15px 20px;
    cursor: pointer;
    &.is-answer {
      background: $homework-default-bg;
      color: $homework-default-color;
    }
    &.is-right {
      background: $homework-right-bg;
      color: $homework-right-color;
    }
    &.is-wrong {
      background: $homework-wrong-bg;
      color: $homework-wrong-color;
    }
  }
}

// 客户端
.answer-sheet-wrap-electron.answer-sheet-wrap {
  .drawer {
    left: calc(50% + #{$side-bar-width} / 2 - 3px);
  }
}

// 适配
@media (max-width: 1200px) {
  .drawer {
    width: calc(100% - 30px);
  }
}
</style>
